import type {
  GenericScreenMapInterface,
  GenericScreenDeckMapInterface,
} from './GenericScreenTypes';
import { GenericScreenTypes } from './GenericScreenTypes';
import type { UnitInfoGenericScreenInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';

export const GenericSceenData: GenericScreenMapInterface = {
  [GenericScreenTypes.INCLINED_SCREEN]: { availableDecks: [1, 2, 3, 4] },
  [GenericScreenTypes.HORIZONTAL_SCREEN]: { availableDecks: [1, 2, 3] },
  [GenericScreenTypes.SCALPING_SCREEN]: { availableDecks: [2, 3] },
  [GenericScreenTypes.MULTISLOPE_SCREEN]: { availableDecks: [1, 2] },
  [GenericScreenTypes.GRIZZLY_SCREEN]: { availableDecks: [1, 2] },
};

export const getDeckList = (modelType: string) => {
  return GenericSceenData[modelType]?.availableDecks.reduce(
    (acc: GenericScreenDeckMapInterface, curr, i) => ({
      ...acc,
      [i]: {
        separationSize: defaultSeparationSize[curr],
        display: { separationSize: true },
      },
    }),
    {} as GenericScreenDeckMapInterface,
  );
};

export const availableDecks = (modelName: string) => {
  const { availableDecks } = GenericSceenData[modelName];
  return availableDecks;
};

const defaultSeparationSize: Record<number, number> = {
  1: 50,
  2: 25,
  3: 12,
  4: 6,
};

export const getDefaultGenericScreen = (): UnitInfoGenericScreenInterface => {
  return {
    modelName: GenericScreenTypes.INCLINED_SCREEN,
    parallelUnits: 1,
    moisture: 0,
    newMoisture: false,
    deckList: getDeckList(GenericScreenTypes.INCLINED_SCREEN),
    nbrOfDecks: 1,
    materialType: { name: '', value: '' },
    mirrored: false,
    display: {
      displayModelName: true,
      displayUnitName: true,
      displayLoad: true,
      displayDescription: true,
      displayNumberOfDecks: false,
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
    },
  };
};

export class GenericScreenConfig extends BaseUnitConfig {
  static getDefaultData(): UnitInfoGenericScreenInterface {
    return {
      modelName: GenericScreenTypes.INCLINED_SCREEN,
      ...BaseUnitConfig.getBaseDefaults(),
      deckList: getDeckList(GenericScreenTypes.INCLINED_SCREEN),
      nbrOfDecks: 1,
      materialType: { name: '', value: '' },
      mirrored: false,
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayDescription: true,
        displayNumberOfDecks: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 3;
  }
}

export const genericScreenConfig = new GenericScreenConfig();
